import React from "react";
import { Input, Select } from "antd";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

const Filters = props => {

  const { filterText, filterOrder, setFilterOrder, setFilterText, setSearchValue } = props;
  const folders = useSelector(state => state.folders);
  const foldersList = folders.folders;
  const filtersText = useIntl().formatMessage({
    id: "folders.pages.list.filters.text"
  });

  return (
    <div
      className="Fascicoli-list-filters"
      style={{
        display:
          folders.isGettingFolders ||
          (foldersList && foldersList.length === 0 && !folders.isGettingFolders)
            ? "none"
            : ""
      }}
    >
      <div className="Fascicoli-list-filters-left">
        <div><FormattedMessage id="actions.search" /></div>
        <div>
          <Input.Search
            onSearch={value => setSearchValue(value)}
            enterButton
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            placeholder={filtersText}
          />
        </div>
      </div>
      <div className="Fascicoli-list-filters-right">
        <div>&nbsp;</div>
        <div>
          <Select value={filterOrder} onChange={value => setFilterOrder(value)}>
            <Select.Option value="new"><FormattedMessage id="folders.filters.new" /></Select.Option>
            <Select.Option value="old"><FormattedMessage id="folders.filters.old" /></Select.Option>
            <Select.Option value="update_new">
              <FormattedMessage id="folders.filters.update_new" />
            </Select.Option>
            <Select.Option value="update_old">
              <FormattedMessage id="folders.filters.update_old" />
            </Select.Option>
            <Select.Option value="az"><FormattedMessage id="folders.filters.az" /></Select.Option>
            <Select.Option value="za"><FormattedMessage id="folders.filters.za" /></Select.Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default Filters;
